import React from "react";
import './NewProjectButton.css'

const NewProjectButton = ({ handleNewProjectClick, isCreatingProject }) => {
    return (
        <button 
            className={`btn-add-project ${isCreatingProject ? 'disabled' : ''}`}
            onClick={handleNewProjectClick} 
            disabled={isCreatingProject}
        >
            <span>+ New Project</span>
        </button>
    )
}

export default NewProjectButton;